import React from 'react';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { useParams } from 'react-router-dom';

import { yupResolver } from '@hookform/resolvers/yup';
import { setComments } from 'services/attorney-profile';
import { useAttoreyProfile } from 'contexts/attorney-profile';

import TextArea from 'components/textarea';
import Button from 'components/button';

import saveIcon from 'assets/images/save.svg';
import greenCrossIcon from 'assets/images/greenCrossIcon.svg';
import style from './comment.module.scss';
import { createNotification } from 'components/react-notification';

const EditComments = ({
  data,
  setToggle,
  setDisable,
  setEdit,
  index,
  onSubmit: submitted,
}) => {
  const { id } = useParams();
  const { getData } = useAttoreyProfile();

  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm({
    defaultValues: { ...data },
    resolver: yupResolver(schema),
  });

  const onSubmit = async (data) => {
    const { comment } = data;

    try {
      const response = await setComments(
        {
          comment,
          commentFor: id,
          commentDate: new Date(),
          commentType: 'attorneys',
        },
        data._id
      );
      submitted(response.data.comment);
    } catch (err) {
      createNotification(
        'error',
        'Error',
        err?.response?.data?.error || err?.message || 'Server Error'
      );
      console.error('err', err.response.data);
    }
    setEdit(false);
    setToggle(false);
    getData();
  };

  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      className={style.addCmntSection}
      key={index}
    >
      <TextArea
        label={'Comment'}
        placeholder={'Start typing'}
        name="comment"
        register={register}
        errorMessage={errors?.comment?.message}
      />

      <div className={style.btnSection}>
        <img
          src={greenCrossIcon}
          onClick={() => {
            setToggle(false);
            setEdit(false);
            setDisable(false);
          }}
        />
        <Button
          text={'Save'}
          type={'submit'}
          width="100px"
          iconStart={saveIcon}
          btnClass={style.btnClass}
          isLoading={isSubmitting}
          onClick={() => {
            setDisable(false);
          }}
        />
      </div>
    </form>
  );
};

export default EditComments;

const schema = yup
  .object({
    comment: yup.string().required('Comment is required'),
  })
  .required();
